<template>
  <div id="app">

    <div class="header" id="app-header__placeholder" style="position: relative"></div>
      <div class="header" ref="pageHeader" id="app-header">
        <div id="header_setting__button" style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;gap: .5em;overflow: hidden">
          <i class="iconfont icon-menu" ref="settingBtn"     style="color: var(--text-color)" @click="menuVisible = !menuVisible"></i>
        </div>
        <div><i class="iconfont" :class="$route.meta.icon||'icon-home'"></i>&thinsp;{{ $route.meta.name||'旅途向导者' }}</div>
        <div class="theme-switch" data-intro="测试提示文本" ref="themeSwitch">
          <van-switch active-value="dark"  id="theme-switch" inactive-value="light" size="18" :value="theme" @change="toggleTheme(theme==='dark'?'light':'dark')"></van-switch>
          <i class="iconfont" id="theme-icon" style="display: none" :class="$store.state.theme==='dark'?'icon-moon':'icon-sun'"></i>

        </div>
      </div>


    <router-view id="app-content" />
    <use-notice-for-user-page :show="!$store.state.isReadNoticeForUser"></use-notice-for-user-page>
    <global-setting v-model="menuVisible"></global-setting>
    <evan-footer v-if="!$route.meta.hasOwnProperty('footer')||$route.meta.footer"></evan-footer>
    <van-overlay :show="showDownloadImage" @click="showDownloadImage = false">
      <img :src="downloadImage" style="width: 100%;height: 80vh;margin: 10vh 0; object-fit: contain;" alt="downloadImages"/>
    </van-overlay>
    <van-image-preview ref="imagePreview" v-model="showPreviewImage"
                       :images="previewImageList"
                       :start-position="previewStartIndex"
                       @change="changeActivePreviewImageIndex"
                       closeable
                       @closed="previewImageList=[]">
      <template #cover >
        <div style="position: absolute;left: 0;right: 0;bottom:20px;display: flex;flex-direction: row;justify-content: center;align-self: center">
          <van-tag round  style="height: 2em;" color="#5232e74e !important" text-color="#5232e7 !important"  ><i class="iconfont icon-download"></i> 长按屏幕保存图片</van-tag>
        </div>
      </template>
    </van-image-preview>
  </div>
</template>
<script>
import packages from "/package.json";
import {EventBus} from "@/main";
import {EventBusKey} from "@/constant/Constants";
import EvanClock from "@/components/EvanClock.vue";
import {loadDriverSteps} from "@/utils/DriverSteps";
import EvanFooter from "@/components/EvanFooter.vue";
import GlobalSetting from "@/components/GlobalSetting.vue";
import {HandleScroll} from "@/utils/mixin/handleScroll";
import {f} from "@/utils/global-config";
import {HandleResize} from "@/utils/mixin/handleResize";
import UseNoticeForUserPage from "@/views/agreement/UseNoticeForUserPage.vue";

export default {
  mixins: [HandleScroll,HandleResize],
  components: {UseNoticeForUserPage, GlobalSetting, EvanFooter, EvanClock},
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
  data() {
    return{
      projectVersion: packages.version,
      showDownloadImage: false,
      downloadImage: '',
      previewCard:false,
      //theme: 'dark',
      menuVisible: false,



      showPreviewImage:false,
      previewImageList: [],
      previewStartIndex: 0,
      currentPreviewImageIndex: 0,

    }
  },
  methods:{
    changeActivePreviewImageIndex(index) {
      this.currentPreviewImageIndex = index;
    },
    loadSteps() {
      let arrays = [];
      let _this = this;
      let arr = [{
        element: _this.$refs.themeSwitch,
        title: `主题切换`,
        targetValue: 'intro.themeSwitch',
        intro: '网站自动设置每天的06:00~20:00应用浅色模式、20:00~次日06:00应用深色模式，但如果这不符合您的预期，您可以通过此按钮进行手动切换；',
      },]
      loadDriverSteps(arr)
    },
    toggleTheme(value) {
      // 切换主题
      console.log('themevalue', value);
      document.body.classList.toggle('dark', value === 'dark');
      this.$store.commit('commitValue',{key:'theme', value: value})

    },
    getRandomColor() {

      const r = Math.floor(Math.random() * 256);


      const g = Math.floor(Math.random() * 256);


      const b = Math.floor(Math.random() * 256);


      return `rgba(${r}, ${g}, ${b},.5)`;
    },
    openEffects() {
      let _this = this;
      document.getElementById('app').addEventListener('click', this.handleClick);
    },// 点击事件处理函数
    handleClick(e) {
      // 注意：这里的this指向Vue实例
      const _this = this;
      const element = e.currentTarget;

      const { clientX, clientY } = e;
      const randomColor = _this.getRandomColor();
      const rippleElement = document.createElement('span');
      rippleElement.setAttribute('data-html2canvas-ignore',true)
      rippleElement.style.backgroundColor = randomColor;
      rippleElement.classList.add('ripple');
      element.appendChild(rippleElement);

      // 计算点击位置
      const rect = element.getBoundingClientRect();
      const rippleX = clientX - rect.left - (rippleElement.offsetWidth / 2);
      const rippleY = clientY - rect.top - (rippleElement.offsetHeight / 2);
      rippleElement.style.left = `${rippleX}px`;
      rippleElement.style.top = `${rippleY}px`;

      // 动画结束后移除元素
      rippleElement.addEventListener('animationend', function() {
        rippleElement.remove();
      });
    },
    closeEffects() {
      let _this = this;
      document.getElementById('app').removeEventListener('click', this.handleClick);
    },
    getWebsiteConfiguration() {
      let item = localStorage.getItem('www.static.lijun.space');
      f(this, item);
      //this.updateGlobalFontFamilyVar('--font-family', this.sysFont);
    },
  },
  mounted() {
    // 根据时间设置主题
    // 设置当前日期
    const now = new Date();
    const hours = now.getHours();
    const isDaytime = hours >= 6 && hours < 20;

    if (!isDaytime) {
      document.body.classList.add('dark');
    }

    this.$store.commit('commitValue',{key:'theme', value: isDaytime ? 'light' : 'dark'})
    this.getWebsiteConfiguration();
    this.loadSteps()
    EventBus.$on(EventBusKey.generateImage, (data)=> {
      this.downloadImage = data.downloadImage;
      this.showDownloadImage = data.showDownloadImage;
    })
    EventBus.$on(EventBusKey.menuVisible,data =>{
      this.menuVisible = data;
    })
    EventBus.$on(EventBusKey.previewImages, (imageList,index=0) => {
      this.previewImageList = imageList;
      this.previewStartIndex = index;
      this.currentPreviewImageIndex = index;
      this.showPreviewImage = true;
    });
    var pageHeader = this.$refs.pageHeader;
    console.log(pageHeader.offsetWidth, pageHeader.offsetHeight, pageHeader);
    this.$store.commit('commitValue',{key:'headerWidth', value: pageHeader.offsetWidth})
    this.$store.commit('commitValue',{key:'headerHeight', value: pageHeader.offsetHeight})
  },
  watch: {
    '$store.state.showEffects':{
      handler(newVal, oldVal) {
        console.log()
        if (newVal) {
          this.openEffects();
        }else{
          this.closeEffects();
        }
      },
      immediate: true,

    },
    '$route':{
      handler(newVal, oldVal) {
        console.log('路由变化：', newVal, oldVal);
        this.menuVisible = false;
      },
    }

  },
  beforeDestroy() {
    EventBus.$off(EventBusKey.generateImage)
    EventBus.$off(EventBusKey.menuVisible);
    EventBus.$off(EventBusKey.previewImages);
  }
}
</script>
<style lang="scss">
.theme-switch {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.theme-icon {
  font-size: 18px;
}
.theme-switch .van-switch{
  border-color: var(--border-color);
  background-color: var(--bg-color) !important;
}
.theme-switch .van-switch__node::before {
  content: var(--theme-icon);
  font-family: 'iconfont';
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: initial;
  color: var(--text-color);
}
.theme-switch  .van-switch__node {
  box-shadow: none !important;
  background-color: var(--header-bg) !important;
}

.header {
  z-index: 2;
  background: var(--bg-color);
  color: var(--text-color);
  padding: 10px 10px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  width: 100%;
  height: 3em;
  outline: none;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  position: fixed;
  left: 0;
  top: 0;

  h1 {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
}
</style>
